<script>
    let process = "client";
    import { beforeUpdate, createEventDispatcher, onMount } from 'svelte';
    import { sortByLabel } from '../shared/utils/Sort.svelte'
		import { fetchData, isTouchEnabled, filter } from '../shared/utils/Data.svelte'
    import Fuse from 'fuse.js';
    import { fade } from 'svelte/transition';
		import Paginate from '../shared/grid/Paginate.svelte';
		import { debounce } from '../shared/grid/debounce';
		import * as local from '../shared/grid/local';
		import { collect, exportExcel, print } from '../shared/grid/data-grid';
		import Identity from 'svelte-key';
		import { generateID } from '../shared/utils/Data.svelte';
    import { immerStore } from '../shared/grid/store';
		import { today, print as printIcon, arrowRoundBack, eye, download, search as searchIcon, create, funnel, list, paper } from 'ionicons/icons/index.mjs';
		import PowerTable from './PowerTable.svelte';
		import { dataStore } from '../stores/source';
		import Link from './Link.svelte';
		import '../../scss/power-table.scss';
		import '../../scss/power-table-mascara.scss';
		

	export let tooltips;
	export let source = {
		type: "FeatureCollection",
		features: []
	};
  export let content;
	export let session;
	export let clickable = true;
	export let printable = true;
	export let exportable = true;
	export let searchable = false;
	export let searching = false;
	export let searchInputRef = null;
	export let searchInput = '';

	export let sortable = true;
	export let sortColumn = -1;
	export let sortType = 'asc';

	export let currentPerPage = 1000;
	export let perPageOptions = [];
	export let currentPage = 1;
	export let rowCount = 0;
	export let pageCount = 0;
  export let selected = 0;
	export let perPage = [1000, 5000, 10000];
	export let paginate = { size: perPage[0], page: 1 };
	export let defaultPerPage = null;
	export let exactSearch = true;		
	export let mode = "";
	export let templates;
	let rows = [];
	let myPowerTable = null;
	let features = [];
	let ptOptions = {
    segments: {
        'pTable': ['table']
    },
		footerText: false,
		footerFilters: false,
	}

	let keys = {
		rows: "1",
		columns: "1"
	}
	let columns = [];
	export let filters = {};
	let filterChanged = false;
	let activeIndex = -1;
	let activeRow = null;
	let params = (new URL(document.location)).searchParams;
	if (params.get("p") !== null) {
		currentPage = Number(params.get("p"));
	}
	else if (content.page) {
		//currentPage = Number(content.page);
	}
	if (params.get("s") !== null) {
		var index = params.get("s");
		sortColumn = Number(index);
		if (params.get("d") !== null) {
			sortType = params.get("d");
		}
	}
	if (params.get("r") !== null) {
		defaultPerPage = Number(params.get("r"));
	}
	if (params.get("k") !== null) {
		var fields = params.get("k").split(",")
		if (params.get("v") !== null) {
			var values = params.get("v").split(",")
			fields.map(function (field, i) {
				filters[field] = values[i] 
			})
			filterChanged = true
		}
	}


  let title = "";
	let ptInstructs = [];
	export let paginatedRows = [];
	// server
	export let paged = { paginate: paginate };

	const dispatch = createEventDispatcher();

  const paginated = immerStore({
		paginatedRows,
		rows,
		paginate,
		size: currentPerPage,
		page: currentPage,
  });
    
	export function search(e) {
		e.currentTarget.blur();
		searching = !searching;
		if (searching) {
			setTimeout(() => searchInputRef.focus(), 100);
		}
	}

	function onFilter(column, value) {
		if (value)
			filters[column] = value
		else
			delete filters[column]
		filterChanged = true
		let params = (new URL(document.location)).searchParams;
		params.set("k", Object.keys(filters));
		params.set("v", Object.values(filters));
		history.replaceState(content, "", window.location.origin + "/tables/" + content.table.id + "?" + params.toString());	
	}

	export function setSortIcon(index) {
		if (!sortable)
			return;
		if (sortColumn == index) {
			sortType = sortType === 'asc' ? 'desc' : 'asc';
		} else {
			sortType = 'asc';
			sortColumn = index;
		}
		sortType = sortType, sortColumn = sortColumn;
	}

	export function setPerPageOptions() {
		let options = perPage;
		// Force numbers
		options = options.map( v => parseInt(v));		
		// Set current page to first value
		currentPerPage = options[0];	
		// Sort options
		options.sort((a,b) => a - b);	
		// And add "All"
		//options.push(-1);	
		// If defaultPerPage is provided and it's a valid option, set as current per page
		if (options.indexOf(defaultPerPage) > -1) {
			currentPerPage = parseInt(defaultPerPage);
		}	
		currentPerPage = currentPerPage, perPageOptions = options;
	}

	export function click(row, y) {
		if (!clickable) {
			return;
		}
		activeIndex = y;
		activeRow = row;
		if (getSelection().toString()) {
			// Return if some text is selected instead of firing the row-click event.
			return;
		}
		dispatch('row-click', row);
		keys.rows = generateID();
		if (mode == "embed") {
			let feature = {
				properties: $dataStore[activeRow["__PT_ID__"]],
				geometry: $dataStore[activeRow["__PT_ID__"]].geometry
			};
			let index = -1;
			if (content.table && content.table.summaries) {
				let summaries = content.table.summaries.split(",");
				if (summaries.length == 1) {
					index = templates.findIndex(x => x.id == summaries[0]);
				}
			}

			if (index != -1) {
				sendMessage({
				type: "modal",
				data: {
						view: "summary",
						template: templates[index],
						feature: feature,
						layer: content.table.media_id,
						feature_id: feature.properties[content.table.id_field]
					}
				})
			} else {
				sendMessage({
					type: "modal",
					data: {
						view: "item",
						feature: feature,
						table: content.table
					}
				})
			}
		}
		
		// console.log('click', row);
	}

	export function sort(index) {
		if (index > -1) {
			setSortIcon(index);
			getPaged({colName: columns[index].field, direction: sortType}, null, true);
			let params = (new URL(document.location)).searchParams;
			params.set("s", index);
			params.set("d", sortType);
			history.replaceState(content, "", window.location.origin + "/tables/" + content.table.id + "?" + params.toString());			
		}
	}

	function rowsChanged(event) {
		let params = (new URL(document.location)).searchParams;
		params.set("r", event.target.value);
		history.replaceState(content, "", window.location.origin + "/tables/" + content.table.id + "?" + params.toString());
	}

	onMount(async () => {
		columns = [];
		rows = [];
		title = "";
		if (content.table && content.table.name)
				title = content.table.name;
		dataStore.set([]);
		getData();
	});

	async function getData() {
		let features = [];
		if (content.table && content.table.dynamic) {
			features = await getList();
		}
		else {
			features = await getListLocal();
		}

		let rows = features.map(function (feature) {
			let row = feature.properties;
			row.geometry = feature.geometry;
			return row;
		});

		let columnNames = {};
		if (content.table && content.table.fields) {
			content.table.fields.split(",").map(function (field, i) {
				if (sortColumn == -1 && field == content.table.sort_field) {
					sortColumn = i;
				}
				columnNames[field] = {
						key: field
				}
				if (field.includes("maplink")) {
					columnNames[field].parseAs = "unsafe-html"
				}
			})
		}
		columns = Object.values(columnNames);

		/*if (mode == "embed") {
			columns.unshift({
				key: "View",
				title: "",
				sortable: false,
				filterable: false,
				parseAs: "component",
				dataComponent: Link
			})
		}*/
		dataStore.set(rows);
		ptInstructs = columns;
	}

	/*function getPagedLocal(props, pred) { 	
		if (!props)
			props = {};	
		const values = local.getPaged(props, pred, {	
			paginate, selected,
			currentPage, currentPerPage,
      sortable, sortColumn, sortType, 
			searchInput, exactSearch,
			rowCount, pageCount, 
			rows, columns, filters
		});
		({	paginate, selected,
			currentPage, currentPerPage,
      sortable, sortColumn, sortType,
			searchInput, exactSearch,
			rowCount, pageCount,
			rows, paginatedRows, filters
		} = values);
		if (paginatedRows.length == 0) {
			currentPage = 1;
			selected = 0;
		}
		update(paginatedRows, currentPerPage, selectedPage);
	}*/

	async function getList(p) {
			/*if (!p) {
				p = Object.assign({}, paginate);
			}
			var ids = content.table.source.split("_");
			if (ids.length != 3)
				return {};
			if (sortColumn == -1 && content.table.sort_field) {
				p.sort = "[" + content.table.sort_field + "]";
			}
			else if (sortColumn != -1) {
				p.sort = "[" + columns[sortColumn].field + "] " + sortType
			}
			else {
				p.sort = "[" + columns[0].field + "]"
			}
			var filters = []
			if (p.filters) {
				Object.keys(p.filters).map(function (key) {
					filters.push(key + " LIKE '" + p.filters[key] + "%'")
				})
			}*/
		var ids = content.table.source.split("_");
		if (ids.length != 3)
				return [];
		let [res, err]  = await fetchData("/v1/tables/" + ids[1] + "_" + ids[2], {
				method: "POST",
				headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + session.token
				},
      body: JSON.stringify({
				page: 1,
				size: 10000,
				sort: "",
				filters: ""
			})
    });
		if (err) {
			console.log(err);
			return [];
		} 

		/*if (res.rowCount)
			p.total = res.rowCount;
		p.pages = Math.ceil(p.total / p.size);
		if (currentPage > p.pages) {
			currentPage = 1;
			selected = 0;
		}
		source = {
			type: "FeatureCollection",
			features: res.features
		}
		var rows = [];
		source.features.map(function (feature, i) {
			feature.properties["__index"] = i;
			rows.push(feature.properties);
		})
		//const paged = { paginate: p, rows: rows };
		//return paged;*/
		return res.features;
	}
  
	async function getListLocal(p) {
		/*if (!p) {
			p = Object.assign({}, paginate);
		}
		if (sortColumn == -1 && content.table.sort_field) {
			p.sort = content.table.sort_field;
		}
		else if (sortColumn != -1) {
			p.sort = columns[sortColumn].field
		}
		else {
			p.sort = columns[0].field
		}
		var reverse = false
		if (sortType == "desc") {
			reverse = true
		}

		var count = 0
		const [features, total] = filter(filters, p.size, p.page, p.sort, reverse, total)

		p.total = total;
		p.pages = Math.ceil(p.total / p.size);
		if (currentPage > p.pages) {
			currentPage = 1;
			selected = 0;
		}
		source = {
			type: "FeatureCollection",
			features: features
		}
		var rows = [];
		source.features.map(function (feature, i) {
			feature.properties["__index"] = i;
			rows.push(feature.properties);
		})*/
		//const paged = { paginate: p, rows: rows };
		//return paged;

		const [features, total] = filter(filters, 10000, 1, "", false, total)
		return features;
	}

	function getPagedServer(props, pred, paged, cb) {
			const { paginate, getList } = paged;
			if (getList && (!pred || pred(paginate))) {
					const p = Object.assign({}, paginate, props);
					getList(p).then(data => {
							cb(data);
					});		
			}
	}

	function getPagedLocal(props, pred, paged, cb) {
			const { paginate, getListLocal } = paged;
			if (getListLocal && (!pred || pred(paginate))) {
					const p = Object.assign({}, paginate, props);
					getListLocal(p).then(data => {
							cb(data);
					});		
			}
	}
	
	function updateServer(paged) {
		const { paginate } = paged;
		rowCount = paginate.total;
		pageCount = paginate.pages;				
		currentPage = paginate.page;
		if (paged.getList) {
			getList = paged.getList;	
		}
	}
	function updatePaged(data) {
		updateServer(data);
		update(data.rows, data.paginate.size, data.paginate.page);
	}

	function getPaged(props, pred, local) {
		if (content.table && content.table.dynamic && !local) {
			getPagedServer(props, pred, { paginate, getList }, updatePaged);
		} else {
			getPagedLocal(props, pred, { paginate, getListLocal }, updatePaged);
		}
	}	
	
	$: selectedPage = selected + 1;
	let previous;	
	function update(paginatedRows, size, page) {
		paginated.update($paginated => {
			$paginated.paginatedRows = paginatedRows;
			$paginated.rows = rows;
			$paginated.size = size;
			$paginated.page = page;
		});
		previous = $paginated;
	}

	/*$: {
		// console.log('$paginated - previous - selectedPage ', $paginated.page, previous ? previous.page : -1, selectedPage);
		if (previous) {
			let changed = false;
			if (rows !== previous.rows) {
				getPaged({ rows });
			}
			if (currentPerPage !== previous.size) {
				getPaged({ size: currentPerPage });
			}
			if (selectedPage !== previous.page) {
				getPaged({ page: selectedPage }, x => x.page != selectedPage);
				paginate.page = selectedPage;
			}
			if (changed) {
				getPaged({ rows, size: currentPerPage, page: selectedPage });
			}
		}
		previous = $paginated;
	}*/

	let prevPaged;
	$: if (paged.rows && paged !== prevPaged) {
		updatePaged(paged);
		prevPaged = paged;
	}

	let prevSearchInput = '';
	beforeUpdate(() => {			     
		if (filterChanged) {
			debounce(() => {
				getPaged({ filters });
				filterChanged = false
			}, 400)();
		}	        
  });
    
	function pageClick(index) {
		let params = (new URL(document.location)).searchParams;
		params.set("p", index);
		content.page = index;
		history.replaceState(content, "", window.location.origin + "/tables/" + content.table.id + "?" + params.toString());
	}

	function sendMessage(message) {
		dispatch('message', message);
  }

	function printFeatures() {
    let win = window.open("");
    win.document.write(renderTable(columns, rows));
    win.print();
    win.close();
	}

	function renderTable() {
    let table = '<table><thead>';
		let columns = content.table.fields.split(",");
    table += '<tr>';
    for (let i = 0; i < columns.length; i++) {
        const column = columns[i];
        table += '<th>';
        table += 	column;
        table += '</th>';
    }
    table += '</tr>';

    table += '</thead><tbody>';
    
		if (!myPowerTable)
			return;
		let exportRows = myPowerTable.getData(true, ['matchedData']).matchedData;
    for (let i = 0; i < exportRows.length; i++) {
        const feature = exportRows[i];
        table += '<tr>';
        for (let j = 0; j < columns.length; j++) {
            const column = columns[j];
            table += '<td>';
           	if (feature[column])
							table += feature[column]
            table += '</td>';
        }
        table += '</tr>';
    }

    table += '</tbody></table>';
    return table;
	}

	function exportFeatures() {
		const mimeType = 'data:text/csv';
		const html = renderCSV();

		const documentPrefix = title
		const d = new Date();

		var dummy = document.createElement('a');
		dummy.href = mimeType + ', ' + html;
		dummy.download = title
				+ '-' + d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate()
				+ '-' + d.getHours() + '-' + d.getMinutes() + '-' + d.getSeconds()
				+'.csv';
		dummy.click();
	}

	function renderCSV() {
			let table = '';
			let columns = content.table.fields.split(",");
			for (let i = 0; i < columns.length; i++) {
					const column = columns[i];
					table += '"' + column + '"';
					table += ',';
			}
			table += '\r\n';
			
			if (!myPowerTable)
				return;
			let exportRows = myPowerTable.getData(true, ['matchedData']).matchedData;
			for (let i = 0; i < exportRows.length; i++) {
					const feature = exportRows[i];
					for (let j = 0; j < columns.length; j++) {
							const column = columns[j];
							if (feature[column])
									table += '"' + feature[column] + '"';
							else
									table += '""';
							table += ',';
					}
					table += '\r\n';
			}

			return table;
	}
</script>

<div id="stage" class="container panel" style={mode == "embed" ? "padding:0;" : ""} in:fade>
	{#if mode != "embed"}
	<div class="panel-header">
    <div class="tile tile-centered">
		<div class="tile-content">
			<div class="h5 tile-title" style="padding-left:1.5rem;">{title}</div>
		</div>
		<div class="tile-action">
			<div class="actions">
				<button
					class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="New Report"
					on:click="{(e) => {
						e.currentTarget.blur();
						sendMessage({
							type: "report",
							data: {
								form: content.table.form
							}
						})
					}}">
					<i class="svg">{@html today.md}</i>
				</button>
				<button
					class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View"
					on:click="{async (e) => {
						e.currentTarget.blur();
						if (!activeRow)
							return
						/*history.replaceState(content, "", window.location);
						var data = {
								view: "item",
								feature: source.features[activeRow["__index"]],
								table: content.table
						}
						sendMessage({
							type: "content",
							data: data
						})*/
						let feature = {
							properties: $dataStore[activeRow["__PT_ID__"]],
							geometry: $dataStore[activeRow["__PT_ID__"]].geometry
						};
						if (content.table.dynamic) {
							const parts = content.table.source.split("_");
							if (parts.length == 3) {
								let [res, err]  = await fetchData("/v1/tables/" + parts[1] + "_" + parts[2] + "/" + feature.properties[content.table.id_field], {
										method: "GET",
										headers: {
												'Content-Type': 'application/json',
												'Authorization': 'Bearer ' + session.token
										}
								});
								if (!err && res && res.features.length == 1) {
									feature = res.features[0];
								} 
							}
						}
						sendMessage({
                  type: "modal",
                  data: {
                    view: "item",
                    feature: feature,
										table: content.table
                  }
                })
						//var url = window.location.origin + "/tables/" + data.table.id + "?f=" + data.feature.properties[content.table.id_field];
						//history.pushState(data, "", url);
					}}">
					<i class="svg">{@html eye.md}</i>
				</button>
				<button
					class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Edit"
					on:click="{async (e) => {
						e.currentTarget.blur();
						if (!activeRow)
							return
						let feature = {
							properties: $dataStore[activeRow["__PT_ID__"]],
							geometry: $dataStore[activeRow["__PT_ID__"]].geometry
						};
						if (content.table.dynamic) {
							const parts = content.table.source.split("_");
							if (parts.length == 3) {
								let [res, err]  = await fetchData("/v1/tables/" + parts[1] + "_" + parts[2] + "/" + feature.properties[content.table.id_field], {
										method: "GET",
										headers: {
												'Content-Type': 'application/json',
												'Authorization': 'Bearer ' + session.token
										}
								});
								if (!err && res && res.features.length == 1) {
									feature = res.features[0];
								} 
							}
						}
						sendMessage({
							type: "edit",
							data: {
								form: content.table.form,
								feature: feature,
							}
						})
					}}">
					<i class="svg">{@html create.md}</i>
				</button>
				{#if printable}
				<button
					class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Print"
					on:click="{(e) => {
						e.currentTarget.blur();
						printFeatures();
					}}">
					<i class="svg">{@html printIcon.md}</i>
				</button>
				{/if}
				{#if exportable}
				<button
					class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Download"
					on:click="{(e) => {
						e.currentTarget.blur();
						if (!title && content.table && content.table.name)
							title = content.table.name;
						exportFeatures();
					}}">
					<i class="svg">{@html download.md}</i>
				</button>
				<button
					class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Export Summary"
					on:click="{(e) => {
						e.currentTarget.blur();
						if (!myPowerTable)
							return;
						let exportRows = myPowerTable.getData(true, ['matchedData']).matchedData;
						if (!title && content.table && content.table.name)
							title = content.table.name;
						sendMessage({
							type: "modal",
							data: {
								view: "summaries",
								type: "item",
								export: true,
								rows: exportRows,
								columns: columns,
								title: title
							}
						})
					}}">
					<i class="svg">{@html paper.md}</i>
				</button>
				{/if}
				{#if searchable}
				<button
					class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Search"
					on:click="{search}">
					<i class="svg">{@html searchIcon.md}</i>
				</button>
				{/if}
				{#if content.table && content.table.summaries}
					<button
						class="btn btn-link tooltip tooltip-left" data-tooltip="Summary"
						on:click="{(e) => {
							e.currentTarget.blur();
							if (!myPowerTable)
								return;
							let exportRows = myPowerTable.getData(true, ['matchedData']).matchedData;
							sendMessage({
								type: "modal",
								data: {
									view: "summaries",
									type: "grid",
									feature: exportRows
								}
							})
						}}">
						<i class="svg">{@html list.ios}</i>
					</button>
				{/if}
				<button
            class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Back"
            on:click="{(e) => {
              e.currentTarget.blur();
              window.history.back()
            }}">
            <i class="svg">{@html arrowRoundBack.md}</i>
          </button>
			</div>
		</div>
	</div>
</div>
{/if}
	<div class="panel-body">
	<PowerTable bind:this={myPowerTable} ptData={$dataStore} {ptInstructs} {ptOptions} on:rowClicked="{(d) => click(d.detail.data)}" />
	</div>
{#if mode != "embed"}
	<div class="panel-footer" style="text-align:center">
		 {$dataStore.length + " features"}
	</div>
{/if}
<!--
	{#if searching}
	<div>
		<div id="search-input-container">
			<label>
				<input type="search" id="search-input" bind:this={searchInputRef}
				 	class="form-input" placeholder="Search data"
					bind:value="{searchInput}">
			</label>
		</div>
	</div>
	{/if}
	</div>
	<div class="panel-body">
    <table  ref="table"
            class="table table-striped table-hover table-scroll">
				<Identity key={keys.columns}>
        <thead>
            <tr>
                {#each columns as column, x}
									<th>
										<div class="tile tile-centered">
											<div class="tile-content" on:click="{() => sort(x)}">
												{column.label}
											</div>
											<div class="tile-action" style="margin-top:-3px">
												{#if sortColumn == x && sortType == 'desc'}
													<i class="icon icon-downward"></i>
												{:else if sortColumn == x && sortType == 'asc'}
													<i class="icon icon-upward"></i>
												{/if}
											</div>
										</div>
										<div>
											<input class="form-input input-sm mb-1" id="filter-{column.field}" type="text" autocomplete="off" on:keyup={function(e) {
												onFilter(column.field, e.target.value)
											}} bind:value="{filters[column.field]}">
										</div>
									</th>
                {/each}
            </tr>
        </thead>
				</Identity>
				<Identity key={keys.rows}>
        <tbody>
            {#each $paginated.paginatedRows as row, y}
                <tr class="clickable { activeIndex == y ? 'active' : '' }" on:click="{() => click(row, y)}">
                    {#each columns as column, x}
                        <td>
                            {#if column.html}
                                {@html collect(row, column.field)}
                            {:else}
                                { collect(row, column.field) }   
                            {/if}     
                        </td>
                    {/each}
                </tr>
            {/each}			
        </tbody>
				</Identity>
    </table>
	</div>
{#if paginate}
	<div class="panel-footer">
		<div class="tile tile-centered">
			<div class="tile-icon">
				<label>
					<span>Rows per page:</span>
					<select class="form-select" style="width:auto;" bind:value="{currentPerPage}" on:change="{rowsChanged}">
						{#each perPageOptions as option, x}
							<option value={option}>
							{ option === -1 ? 'All' : option }
							</option>
						{/each}
					</select>
				</label>
			</div>
			<div class="tile-content text-center">
				{(currentPage - 1) * currentPerPage ? (currentPage - 1) * currentPerPage : 1}
					- {Math.min(rowCount, currentPerPage * currentPage)} of {rowCount}
			</div>
			<div class="tile-action">
				<Paginate
					bind:pageCount={pageCount}
					marginPages="2"
					pageRange="4"
					containerClass="pagination"
					pageLinkClass="page-item"
					prevClass="page-item"
					nextClass="page-item"
					bind:selected="{selected}"
					activeClass="active"
					clickHandler={pageClick}
					currentPage={currentPage}
					>			
				</Paginate>
			</div>
		</div>
	</div>
{/if}
-->
</div>

<style>
	#stage {
		width: 100vw;
		height: 100vh;
	}
	.table.table-scroll {
		padding-bottom: 0;
		height: 100%;
	}
	.panel .panel-header, .panel .panel-body, .panel .panel-footer {
		padding: 0;
	}
	.panel .panel-header {
		border-bottom: 1px solid #00ab5f;
	}
	.panel .panel-footer {
		border-top: 1px solid #00ab5f;
	}
	tr.clickable {
		cursor: pointer;
	}
	table {
		table-layout: fixed;
    width: 100%;
	}
	table tr td {
		padding: 0 0 0 56px;
		height: 48px;
		font-size: 13px;
		color: rgba(0, 0, 0, 0.87);
		border-bottom: solid 1px #DDDDDD;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	table td, table th {
    	border-radius: 0;
	}
	table tr td a i {
		font-size: 18px;
		color: rgba(0, 0, 0, 0.54);
	}
	table tr {
		font-size: 12px;
	}
	table th {
		font-size: 12px;
		font-weight: 500;
		color: #757575;
		cursor: pointer;
		white-space: nowrap;
		padding: 0;
		height: 2rem;
		padding-left: 56px;
		vertical-align: middle;
		outline: none !important;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	table tbody tr:hover {
		background-color: #EEE;
	}
	
	table th:last-child,
	table td:last-child {
		padding-right: 14px;
	}
	table th:first-child, table td:first-child {
		padding-left: 24px;
	}
	.table tbody tr.active, .table.table-striped tbody tr.active {
		background-color: #a9d9bb;
	}
</style>